import {
  DEFAULT_BARCODE_CONTENT,
  DEFAULT_INVENTORY_TAG_CONTENT,
} from "@app/components/editor/workspace/golden-layout-definitions";

import { Component } from "@angular/core";
import { UserService } from "../../services/user.service";
import { User } from "../../data/user";
import { LoaderService } from "../../services/loader.service";
import { fadeInOutAnimation, savingButtonAnimation } from "../../animations";
import { ListingService } from "@app/services/listing.service";

import { Angulartics2 } from "angulartics2";
import { FileService } from "@app/services/file.service";
import { ChangeDetectorRef } from "@angular/core";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { BaseEditorComponent } from "@app/components/platform/base-editor.component";
import { DomSanitizer } from "@angular/platform-browser";
import { CatalogService } from "@app/services/catalog.service";
import { BarcodeFormat, ResourceService } from "@app/services/resource.service";
import { OrderService } from "@app/services/order.service";
import { Order } from "@app/data/order";
import * as _ from "underscore";

@Component({
  templateUrl: "./inventory-tag.component.html",
  animations: [fadeInOutAnimation, savingButtonAnimation],
})
export class InventoryTagComponent extends BaseEditorComponent {
  offset: number = 0;
  selectedMoments = [];
  width: number;
  height: number;
  unit: string = "in";
  selectedOrder: Order;
  barcodeCreationStatus = "";
  criticalMargin: number;
  formats: BarcodeFormat[] = [];

  constructor(
    private angulartics2: Angulartics2,
    sanitizer: DomSanitizer,
    catalogService: CatalogService,
    listingService: ListingService,
    userService: UserService,
    loaderService: LoaderService,
    fileService: FileService,
    changeDetectorRef: ChangeDetectorRef,
    goldenLayoutService: GoldenLayoutService,
    private resourceService: ResourceService,
    orderService: OrderService
  ) {
    super(
      sanitizer,
      catalogService,
      listingService,
      userService,
      loaderService,
      fileService,
      changeDetectorRef,
      goldenLayoutService
    );
    this.field = "inventory_tag";
    this.angulartics2.eventTrack.next({ action: "Opened Tag Page" });
    this.resourceService.getBarcodeFormats().then((barcodeFormats) => {
      this.formats = barcodeFormats;
    });

    var beginOfDay = new Date();
    beginOfDay.setHours(0);
    beginOfDay.setMinutes(0);
    beginOfDay.setSeconds(0);
    var currentDate = new Date();
    this.selectedMoments = [beginOfDay, currentDate];
  }

  protected setUserModel(user: User) {
    user.inventory_tag = user.inventory_tag || {
      html: "",
      width: 3.5,
      height: 2,
      zoom: 1,
      multiple_per_page: false,
      include_variants: true,
      show_cut_lines: false,
      show_critical_margins: true,
      critical_margin: 0.125,
      page_left_margin: 0.25,
      page_right_margin: 0.25,
      page_top_margin: 0.25,
      page_bottom_margin: 0.25,
      structure: DEFAULT_INVENTORY_TAG_CONTENT,
    };
    user.inventory_tag.structure =
      user.inventory_tag.structure || DEFAULT_INVENTORY_TAG_CONTENT;
    super.setUserModel(user);
  }

  protected initDocumentUrl(baseUrl: string) {
    this.documentURL = `${baseUrl}/api/v2/inventory-tags/download?l=`;
  }

  protected initComponent() {
    super.initComponent();
  }

  protected download(): Promise<string> {
    return this.listingService.downloadInventoryTags(
      this.listings,
      this.offset
    );
  }

  protected includeVariants(): boolean {
    return this.userModel.inventory_tag
      ? this.userModel.inventory_tag.include_variants
      : false;
  }

  protected refreshCriticalMargin() {
    this.criticalMargin =
      this.inchToPxFactor * this.userModel.inventory_tag.critical_margin;
  }

  protected refreshDimensions() {
    this.refreshCriticalMargin();
  }
}
